import {customElement, property, state} from 'lit/decorators.js';
import {css, CSSResult, html, LitElement, nothing, unsafeCSS} from 'lit';
import '../event-web-layer/event-web-layer.js';
import close from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-12_close.svg';
import {hideIconFromAssistiveTechnology} from '../icon/icon-accessibility.js';
import styles from './whats-new-tooltip.scss';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';

@customElement('ents-whats-new')
export class WhatsNewTooltip extends LitElement {
  @property({type: String, attribute: 'local-storage-id'})
  private localStorageTooltipId: string = 'ents-whats-new';

  @state()
  private showTooltip: boolean = true;

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(typographyStyles)}`];
  }

  connectedCallback() {
    super.connectedCallback();
    this.evaluateLocalStorageTooltipValue();
  }

  private evaluateLocalStorageTooltipValue() {
    const value = window.localStorage.getItem(this.localStorageTooltipId);
    this.showTooltip = value !== 'dismissed';
  }

  private closeTooltip() {
    this.showTooltip = false;
    window.localStorage.setItem(this.localStorageTooltipId, 'dismissed');
  }

  render() {
    if (!this.showTooltip) {
      return nothing;
    }

    return html`
      <div class="ents-wishlist-whats-new__tooltip-wrapper">
        <div class="ents-wishlist-whats-new__tooltip-arrow"></div>
        <div
          class="ents-wishlist-whats-new__tooltip"
          data-test-ents-whats-new-tooltip
        >
          <button @click="${this.closeTooltip}"
                  aria-label="Tooltip schließen">${hideIconFromAssistiveTechnology(close())}</button>
          <div id="ents-wishlist-whats-new-tooltip" class="ents-copy-small-bold">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
}
